var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-alerts"},_vm._l((_vm.alerts),function(alert,index){return _c('ItemAlert',{key:index,attrs:{"alert":alert}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }